import { createFileRoute } from "@tanstack/react-router";
import { BlueprintButton, BlueprintGrid } from "@/components/blueprint/Blueprint";
import { SEOHead } from "@/components/shared/SEOHead";
import { APP_STORE_URL } from "@/lib/utils";

export const Route = createFileRoute("/qr")({
  component: QRPage,
});

const WEBSITE_URL = "https://www.quuil.com/";

const qrAssets = [
  {
    label: "App Store",
    title: "Download Quuil",
    body: "A branded QR for customer cards, pop-ups, packaging inserts, and printed launch collateral.",
    href: APP_STORE_URL,
    qr: "/qr/quuil-app-store-qr.png",
    card: "/qr/quuil-app-store-card.png",
  },
  {
    label: "Website",
    title: "Visit Quuil",
    body: "A branded QR for people who should land on the website first, including press, venue, and partner material.",
    href: WEBSITE_URL,
    qr: "/qr/quuil-website-qr.png",
    card: "/qr/quuil-website-card.png",
  },
];

function QRPage() {
  return (
    <div className="bp-page qr-page page-enter">
      <SEOHead
        title="Quuil QR Codes"
        description="Branded QR codes for Quuil App Store and website links."
        path="/qr"
        keywords={["Quuil QR code", "Quuil App Store", "Quuil marketing assets"]}
      />

      <section className="bp-section qr-hero">
        <BlueprintGrid />
        <div className="bp-container qr-container">
          <div className="qr-copy">
            <span className="bp-kicker">Brand Assets // QR</span>
            <h1>Quuil QR Codes</h1>
            <p>
              Two scannable Quuil QR codes: one opens the App Store listing, the other opens the website. Each QR also has a larger card version for print proofs and handouts.
            </p>
          </div>

          <div className="qr-grid" aria-label="Quuil QR downloads">
            {qrAssets.map((asset) => (
              <article className="qr-card" key={asset.label}>
                <div className="qr-card-head">
                  <span>{asset.label}</span>
                  <a href={asset.href} target="_blank" rel="noopener noreferrer">
                    Open target
                  </a>
                </div>

                <div className="qr-image-wrap">
                  <img src={asset.qr} alt={`${asset.title} QR code`} width={1200} height={1200} />
                </div>

                <div className="qr-card-body">
                  <h2>{asset.title}</h2>
                  <p>{asset.body}</p>
                </div>

                <div className="qr-actions">
                  <BlueprintButton href={asset.qr}>Download QR</BlueprintButton>
                  <BlueprintButton href={asset.card} variant="ghost">Download card</BlueprintButton>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
